import axios, { AxiosPromise } from 'axios';
import { IBlank } from 'src/infrastructure/interfaces';

export default class BlankService {

  static toggleBlankPublish(blank: IBlank) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/blank/${blank.id}`, blank)
        .then((res) => {
            resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }

  static updateBlank(blank: IBlank, imageFormData?: FormData) {
    if (imageFormData) {
      return new Promise((resolve, reject) => {
        this.uploadImage(imageFormData)
          .then((res) => {
            const src = res.data.file;
            const newBlank = { ...blank, src: src }
            axios
              .put(`/blank/${blank.id}`, newBlank)
              .then((res) => {
                resolve(res.data);
              })
          })
          .catch(error => reject(error));
      });
    } else {
      return new Promise((resolve, reject) => {
        axios
          .put(`/blank/${blank.id}`, blank)
          .then((res) => {
            resolve(res.data);
          })
          .catch(error => reject(error));
      });
    }
  }
  
  static createBlank(title: string, url: string, imageFormData: FormData) {
    return new Promise((resolve, reject) => {
      this.uploadImage(imageFormData)
        .then((res) => {
          const src = res.data.file;
          axios
            .post('/blank', { title, url, src })
            .then((res) => {
              resolve(res.data);
            })
        })
        .catch(error => reject(error));
    });
  }

  private static uploadImage(formData: FormData):AxiosPromise<any> {
    return axios
      .post('/blankUpload', 
            formData, 
            { headers: {'Content-Type': 'multipart/form-data' }})
  }
}


// WEBPACK FOOTER //
// ./src/services/BlankService.ts